const nameLoyaltyTabStyle = () => ({
	inputWrapper: {
		maxWidth: 288,
		margin: '60px auto 196px',
	},
	card: {
		maxWidth: 624,
		marginLeft: 'auto',
		marginRight: 'auto',
	},
});

export default nameLoyaltyTabStyle;
